// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ZiQW","type":"styles_type__3uom6","choices":"styles_choices__3AdNr"};